module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.visual_list), function(visual, index) {
    return _c('transition', {
      key: index,
      attrs: {
        "name": "home-visual__img"
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.now === index),
        expression: "now === index"
      }],
      staticClass: "home-visual__img u-sz-w100",
      attrs: {
        "src": visual,
        "alt": ""
      }
    })])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17341000"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/home/home-visual.vue
// module id = 54
// module chunks = 0